export default __webpack_public_path__ + "static/media/guide.1d12343a.svg";